import { Injectable } from '@angular/core';
import { DashboardPreferencesEntity } from '../../domain/entities/dashboard-preferences.entity';
import {
  DashboardWidgetDataEntity,
  DashboardWidgetDataPointEntity,
  DashboardWidgetDataType,
} from '../../domain/entities/dashboard-widget-data.entity';
import { DashboardWidgetEntity } from '../../domain/entities/dashboard-widget.entity';
import { DashboardPreferencesResponseDto } from '../dtos/dashboard-preferences-response.dto';
import { DashboardWidgetDataResponseDto } from '../dtos/dashboard-widget-data-response.dto';
import { DashboardWidgetResponseDto } from '../dtos/dashboard-widget-response.dto';

@Injectable({ providedIn: 'root' })
export class DashboardMapper {
  public toWidget(dto: DashboardWidgetResponseDto): DashboardWidgetEntity {
    const entity = new DashboardWidgetEntity();
    entity.id = dto.id;
    entity.dashboardViewTypeId = dto.dashboardViewTypeId;
    entity.widgetKey = dto.widgetKey;
    entity.displayName = dto.displayName;
    entity.displayOrder = dto.displayOrder;
    entity.widgetType = dto.widgetType;
    entity.isVisible = dto.isVisible;
    return entity;
  }

  public toWidgetArray(dtos: DashboardWidgetResponseDto[]): DashboardWidgetEntity[] {
    return dtos.map((dto) => this.toWidget(dto));
  }

  public toPreferences(dto: DashboardPreferencesResponseDto): DashboardPreferencesEntity {
    const entity = new DashboardPreferencesEntity();
    entity.hiddenPredefinedFilterIds = dto.hiddenPredefinedFilterIds ?? [];
    entity.hiddenColumnKeys = dto.hiddenColumnKeys ?? [];
    entity.columnOrder = dto.columnOrder;

    entity.advancedFilterRows = dto.advancedFilterRows;
    entity.showCharts = dto.showCharts;
    entity.selectedTimeframe = dto.selectedTimeframe;
    entity.filterFromDate = dto.filterFromDate ?? null;
    entity.filterToDate = dto.filterToDate ?? null;
    entity.canCreateCase = dto.canCreateCase;
    return entity;
  }

  public toWidgetData(dto: DashboardWidgetDataResponseDto): DashboardWidgetDataEntity {
    const entity = new DashboardWidgetDataEntity();
    entity.widgetKey = dto.widgetKey;
    entity.type = dto.type as DashboardWidgetDataType;
    entity.data = dto.data.map((p) => {
      const point = new DashboardWidgetDataPointEntity();
      point.key = p.key;
      point.label = p.label;
      point.value = p.value;
      point.color = p.color;
      point.filter = p.filter;
      return point;
    });
    return entity;
  }
}
